import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import Saving from 'components/Saving/index';
import api from 'api';
import Util from 'utility';
import { __ } from 'locale';
import { loadGlobals, showMessage } from 'actions/index';

const inputRowCls = 'flex w-full flex-wrap items-start py-[4px] [&>img]:self-center [&>span]:w-[15em] [&>span]:basis-[15em] [&>span]:mt-[0.5em] [&>span.error]:text-[#f00] [&>span.error]:font-bold';
const inputsCls = 'flex-1 flex flex-wrap items-center [&>input]:w-full [&>input]:py-[0.35em] [&>input]:px-[0.5em] [&>input]:border [&>input]:border-[#ccc] [&>input]:rounded [&>input]:mr-[0.5em] [&>input]:shadow-[inset_1px_2px_4px_rgba(0,0,0,0.1)] [&>input.short]:w-[6em] [&>textarea]:w-full [&>textarea]:h-[8em] [&>textarea]:py-[0.35em] [&>textarea]:px-[0.5em] [&>textarea]:border [&>textarea]:border-[#ccc] [&>textarea]:rounded [&>select]:w-full [&>select]:py-[0.35em] [&>select]:px-[0.5em] [&>select]:border [&>select]:border-[#ccc] [&>select]:rounded [&>select]:mr-[0.5em]';
const checkLabelCls = 'flex items-center cursor-pointer [&>input]:hidden [&>b]:flex [&>b]:items-center [&>b]:justify-center [&>b]:w-[1.75em] [&>b]:h-[1.75em] [&>b]:text-[0.8em] [&>b]:rounded-full [&>b]:border [&>b]:border-[#ccc] [&>b]:mr-[0.6em] [&>b]:self-center [&>b>i]:text-white [&>input:checked~b]:border-[#26AA52] [&>input:checked~b]:bg-[#26AA52] [&:hover>b]:border-[#26AA52]';

function ProfileCreate() {
    const data = useSelector(state => state);
    const dispatch = useDispatch();
    const history = useHistory();
    const { globals } = data;

    const [saving, setSaving] = useState(false);
    const [profileCreated, setProfileCreated] = useState(false);
    const [createdProfileId, setCreatedProfileId] = useState(0);
    const [vegeRegimesWarning, setVegeRegimesWarning] = useState(false);
    const [errors, setErrors] = useState([]);
    const [profile, setProfile] = useState({
        profile_color: '',
        eating_regimes: [],
        name: '',
        salutation: '',
        persona_key: '',
        birthday_day: 0,
        birthday_month: 0,
        birthday_year: 0,
        height: 0,
        weight: 0,
        diameter_waist: 0,
        diameter_sides: 0,
        photo: '',
    });

    useEffect(() => {
        Util.setPageTitle('Vytvořit profil');
    }, []);

    const onChange = (e) => {
        const key = e.target.name;
        let value = e.target.value;
        const checked = e.target.checked;

        let valueNumeric = value * 1;
        if (value == valueNumeric.toString()) {
            value = valueNumeric;
        }

        if (key === 'photo') {
            value = e.target.files[0];
        }

        if (key === 'eating_regimes[]') {
            setProfile(prev => {
                let newRegimes;
                if (checked) {
                    newRegimes = [...prev.eating_regimes, value];
                } else {
                    newRegimes = prev.eating_regimes.filter(r => r !== value);
                }
                const vegetarianRegimes = [10, 20, 30];
                const numVege = newRegimes.filter(r => vegetarianRegimes.includes(r * 1)).length;
                setVegeRegimesWarning(numVege > 1);
                return { ...prev, eating_regimes: newRegimes };
            });
        } else {
            setProfile(prev => ({ ...prev, [key]: value }));
        }
    };

    const createProfile = () => {
        let errs = [];
        if (profile.name === '') errs.push('name');
        if (profile.salutation === '') errs.push('salutation');
        if (profile.persona_key === '' || profile.persona_key == 0) errs.push('persona_key');
        if (profile.birthday_day == 0) errs.push('birthday_day');
        if (profile.birthday_month == 0) errs.push('birthday_month');
        if (profile.birthday_year == 0) errs.push('birthday_year');
        if (profile.weight == 0) errs.push('weight');
        if (profile.height == 0) errs.push('height');

        setErrors(errs);

        if (errs.length > 0) {
            dispatch(showMessage({ show: true, type: 'error', message: 'Zadejte prosím všechny požadované údaje.' }));
            window.scrollTo(0, 0);
            return false;
        } else {
            dispatch(showMessage({ show: false }));
        }

        setSaving(true);
        let fd = new FormData();
        for (let i in profile) {
            fd.append(i, profile[i]);
        }
        api('profile/create', { post: true, data: fd }).then(result => {
            const createdProfileData = result.data.data;
            api('load/startup-data').then(result => {
                dispatch(loadGlobals(result.data));
                setProfileCreated(true);
                setCreatedProfileId(createdProfileData.profile_id);
            });
        });
    };

    const savingEl = saving ? <Saving /> : false;

    let profileKeys = [];
    profileKeys.push({ id: 0, title: 'Vyberte...' });
    for (let pk in globals.profileKeys) {
        profileKeys.push({ id: pk, title: globals.profileKeys[pk] });
    }

    let birthdayDays = [];
    for (let n = 1; n <= 31; n++) birthdayDays.push(n);

    const birthdayMonths = ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec'];

    let birthdayYears = [];
    for (let n = 1900; n <= (new Date()).getFullYear(); n++) birthdayYears.push(n);

    let profileName = profile.name;
    if (profileName === '') profileName = '\u00A0';

    if (profile.profile_color === '') profile.profile_color = '000000';

    const profileColors = ['000000', 'dd0000', '00cc00', '0088ee', 'ff7700', 'aa00cc', 'ffcc44', 'ff26f2', '00c97b'];
    const profileColorSelect = profileColors.map(color => (
        <div className="col basis-[50%]" key={color}>
            <label className={checkLabelCls}>
                <input type="radio" name="profile_color" value={color} checked={profile.profile_color == color} onChange={onChange} />
                <b><i className="fa fa-check"></i></b>
                <span style={{ padding: '3px 4px', fontSize: '.9em', borderRadius: '4px', backgroundColor: '#' + color, color: '#fff' }}>{profileName}</span>
            </label>
        </div>
    ));

    const eatingRegimes = [];
    for (let r in globals.eatingRegimes) {
        eatingRegimes.push(
            <div className="col basis-[33.33%]" key={r}>
                <label className={checkLabelCls}>
                    <input type="checkbox" name="eating_regimes[]" value={r} checked={profile.eating_regimes.includes(r * 1)} onChange={onChange} />
                    <b><i className="fa fa-check"></i></b>
                    {globals.eatingRegimes[r].title}
                </label>
            </div>
        );
    }

    const energyBalanceOptions = [];
    for (let e in globals.energyBalanceOptions) {
        energyBalanceOptions.push(
            <div className="col" style={{ flexBasis: '100%' }} key={e}>
                <label className={checkLabelCls}>
                    <input type="checkbox" name="energy_balance_option" value={e} checked={profile.energy_balance_option == e} onChange={onChange} />
                    <b><i className="fa fa-check"></i></b>
                    {globals.energyBalanceOptions[e]}
                </label>
            </div>
        );
    }

    const energyOutputCoefficients = [];
    for (let c in globals.energyOutputCoefficients) {
        const coef = globals.energyOutputCoefficients[c];
        energyOutputCoefficients.push(
            <div className="col" style={{ flexBasis: '100%' }} key={c}>
                <label className={checkLabelCls}>
                    <input type="radio" name="energy_output_coefficient" value={c} checked={profile.energy_output_coefficient == c} onChange={onChange} />
                    <b><i className="fa fa-check"></i></b>
                    {coef.title}
                </label>
            </div>
        );
    }

    const energyBalanceSettings = (
        <>
            <h3>Energetická bilance</h3>
            <div className="flex flex-wrap [&>label]:p-0 [&>label]:cursor-pointer [&>.col]:mb-[0.5em]">
                {energyBalanceOptions}
            </div>
        </>
    );

    const vegeRegimesWarningEl = vegeRegimesWarning
        ? <span style={{ marginLeft: '1.5em', fontSize: '.7em', color: '#f00' }}>Upozornění: máte vybrán více než jeden vegetariánský profil.</span>
        : false;

    let newProfileInfo = false;
    if (typeof globals.profiles === 'object' && Object.keys(globals.profiles).length === 0) {
        newProfileInfo = <p style={{ background: '#ffc', color: '#000', padding: '1em', textAlign: 'center' }}>{__('Před použitím aplikace ZOF je třeba nejprve vytvořit svůj profil. Vyplňte prosím následující formulář')}:</p>;
    }

    let content = (
        <React.Fragment>
            <div className="max-w-[1180px] mx-auto px-[1em]">
                <div className="flex-1 p-[2em] mt-[1em] mb-[1em]">
                    <h1>{__('Vytvořte svůj profil')}</h1>
                    {newProfileInfo}
                    <p style={{ margin: '1em 0', background: '#efefef', padding: '1em' }}>{__('Položky označené hvězdičkou jsou povinné. Ostatní můžete vyplnit až později.')}</p>
                    <div className="flex flex-wrap">
                        <div className="flex-1">
                            <h3>{__('Jméno profilu')}</h3>
                            <div className={inputRowCls}>
                                <span className={errors.includes('name') ? 'error' : ''}>{__('Jméno')}:<span className="font-bold text-[#4eb32d] ml-[0.5rem]">*</span></span>
                                <div className={inputsCls}>
                                    <input type="text" name="name" maxLength="50" onChange={onChange} value={profile.name} style={{ fontWeight: 'bold' }} />
                                </div>
                            </div>
                            <div className={inputRowCls}>
                                <span className={errors.includes('salutation') ? 'error' : ''}>{__('Oslovení')}:<span className="font-bold text-[#4eb32d] ml-[0.5rem]">*</span></span>
                                <div className={inputsCls}>
                                    <input type="text" name="salutation" onChange={onChange} value={profile.salutation} />
                                </div>
                            </div>
                            <div className={inputRowCls}>
                                <span className={errors.includes('persona_key') ? 'error' : ''}>{__('Specifikace')}:<span className="font-bold text-[#4eb32d] ml-[0.5rem]">*</span></span>
                                <div className={inputsCls}>
                                    <select name="persona_key" onChange={onChange} defaultValue={profile.persona_key}>
                                        {profileKeys.map(pk => (
                                            <option key={pk.id} value={pk.id}>{pk.title}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <h3>{__('Profilová fotka')}</h3>
                            <div className={inputRowCls}>
                                <span>{__('Foto')}:</span>
                                <div className={inputsCls}>
                                    <input type="file" name="photo" accept="image/*" onChange={onChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap">
                        <div className="col w-full">
                            <h3>{__('Vstupní údaje')}</h3>
                            <div className={inputRowCls}>
                                <span className={(errors.includes('birthday_date') || errors.includes('birthday_month') || errors.includes('birthday_year')) ? 'error' : ''}>{__('Datum narození')}:<span className="font-bold text-[#4eb32d] ml-[0.5rem]">*</span></span>
                                <div className={inputsCls}>
                                    <select style={{ width: '4em' }} name="birthday_day" defaultValue={profile.birthday_day} onChange={onChange}>
                                        <option value="0"></option>
                                        {birthdayDays.map(d => <option key={d} value={d}>{d}</option>)}
                                    </select>
                                    <select style={{ width: '8em' }} name="birthday_month" defaultValue={profile.birthday_month} onChange={onChange}>
                                        <option value="0"></option>
                                        {birthdayMonths.map((d, i) => <option key={i} value={i + 1}>{d}</option>)}
                                    </select>
                                    <select style={{ width: '5em' }} name="birthday_year" defaultValue={profile.birthday_year} onChange={onChange}>
                                        <option value="0"></option>
                                        {birthdayYears.map(d => <option key={d} value={d}>{d}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className={inputRowCls}>
                                <span>{__('Výška')}:<span className="font-bold text-[#4eb32d] ml-[0.5rem]">*</span></span>
                                <div className={inputsCls}>
                                    <input className="short" type="text" name="height" onChange={onChange} value={profile.height} /> cm
                                </div>
                            </div>
                            <div className={inputRowCls}>
                                <span>{__('Váha')}:<span className="font-bold text-[#4eb32d] ml-[0.5rem]">*</span></span>
                                <div className={inputsCls}>
                                    <input className="short" type="text" name="weight" onChange={onChange} value={profile.weight} /> kg
                                </div>
                            </div>
                            <div className={inputRowCls}>
                                <span>{__('Obvod pasu')}:</span>
                                <div className={inputsCls}>
                                    <input className="short" type="text" name="diameter_waist" onChange={onChange} value={profile.diameter_waist} /> cm
                                </div>
                            </div>
                            <div className={inputRowCls}>
                                <span>{__('Obvod boků')}:</span>
                                <div className={inputsCls}>
                                    <input className="short" type="text" name="diameter_sides" onChange={onChange} value={profile.diameter_sides} /> cm
                                </div>
                            </div>
                            <h3>{__('Bazální metabolismus')}</h3>
                            <p>{__('Pokud hodnotu neznáte, nevyplňujte, aplikace ji vypočítá sama.')}</p>
                            <div className={inputRowCls}>
                                <span>{__('Bazální metabolismus')} (BMR):</span>
                                <div className={inputsCls}>
                                    <input className="short" type="text" name="individual_bmr" onChange={onChange} value={profile.individual_bmr} /> kcal
                                </div>
                            </div>
                            <h3>{__('Výdej energie')}<span className="font-bold text-[#4eb32d] ml-[0.5rem]">*</span></h3>
                            <div className="flex flex-wrap [&>label]:p-0 [&>label]:cursor-pointer [&>.col]:mb-[0.5em]">
                                {energyOutputCoefficients}
                            </div>
                            <h3>{__('Stravovací režimy')}<span className="font-bold text-[#4eb32d] ml-[0.5rem]">*</span> {vegeRegimesWarningEl}</h3>
                            <div className="flex flex-wrap [&>label]:p-0 [&>label]:cursor-pointer [&>.col]:mb-[0.5em]">
                                {eatingRegimes}
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-wrap">
                        <div className="col w-full">
                            <h3>{__('Barva profilu')}</h3>
                            <div className={inputRowCls}>
                                <div className="flex flex-wrap [&>label]:p-0 [&>label]:cursor-pointer [&>.col]:mb-[0.5em]">
                                    {profileColorSelect}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-[2em] px-[1em] pt-[2em] pb-[1em] border-t border-[#ccc]">
                        <button onClick={createProfile} className="cursor-pointer bg-[#26AA52] text-white py-[1em] px-[3em] font-bold rounded border-none hover:bg-[#2bbf5c]">{__('Vytvořit profil')}</button>
                    </div>
                </div>
                {savingEl}
            </div>
        </React.Fragment>
    );

    if (!profileCreated && typeof globals.profiles === 'object' && Object.keys(globals.profiles).length > 0) {
        content = <p>V aktuální verzi aplikace je možné vytvořit pouze jeden profil.</p>;
    }

    if (profileCreated) {
        if (Util.isLectureLikeMode(data.appMode)) {
            content = (
                <React.Fragment>
                    <div className="max-w-[1180px] mx-auto px-[1em]">
                        <div className="flex-1 p-[2em] mt-[1em] mb-[1em]" style={{ textAlign: 'center' }}>
                            <h2 style={{ color: '#4eb32d' }}>Profil vytvořen</h2>
                            <p>Váš profil je vytvořen. Kliknutím na tlačítko níže budete přesměrování zpět na úkol.</p>
                            <p style={{ margin: '2em 0' }}>
                                <a className="whitespace-nowrap font-normal text-base bg-[#26AA52] cursor-pointer text-white px-3 py-2 no-underline rounded text-center hover:bg-[#2bbf5c] hover:text-white" onClick={() => window.location.href = '/'}>Pokračovat na úkol</a>
                            </p>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            content = (
                <React.Fragment>
                    <div className="flex-1 p-[2em] mt-[1em] mb-[1em]">
                        <h2 style={{ color: '#4eb32d' }}>Profil vytvořen</h2>
                        <p>Registrací do aplikace jste získali 15 receptů zdarma (najdete je v Kuchařce v sekci <Link to="/cookbook/myrecipes">Moje recepty</Link>).</p>
                        <p>Kam dále?</p>
                        <p>V aplikaci si můžete v databázi potravin označit:</p>
                        <p style={{ textAlign: 'left', margin: '1em 0' }}><b>1. Oblíbené potraviny</b><br /><br />Takto označené potraviny se při tvorbě receptu nabízí přednostně ve speciálním seznamu. Takto si usnadníte opakované vyhledávání těchto potravin, máte všechny na jednom místě.</p>
                        <p style={{ textAlign: 'left', margin: '2em 0 3em 0' }}><b>2. Nežádoucí potraviny</b><br /><br />Potraviny označené jako nežádoucí budou při tvorbě receptu viditelně označeny. Toto je velmi důležité především pro jedince trpící potravinovými introlerancemi a alergiemi. Mohou se tak snadno těchto potravin vyvarovat, případně je nahradit jinými.</p>
                        <p style={{ margin: '2em 0' }}>
                            <a className="whitespace-nowrap font-normal text-base bg-[#26AA52] cursor-pointer text-white px-3 py-2 no-underline rounded text-center hover:bg-[#2bbf5c] hover:text-white" onClick={() => window.location.href = '/food' + createdProfileId}>Označit oblíbené či nevhodné potraviny</a>
                        </p>
                        <p style={{ margin: '2em 0' }}>
                            <Link to="/recipe/me" className="whitespace-nowrap font-normal text-base bg-[#26AA52] cursor-pointer text-white px-3 py-2 no-underline rounded text-center hover:bg-[#2bbf5c] hover:text-white">Prohlédnout 15 receptů zdarma</Link>
                        </p>
                        <p style={{ margin: '2em 0' }}>
                            <a className="whitespace-nowrap font-normal text-base bg-[#26AA52] cursor-pointer text-white px-3 py-2 no-underline rounded text-center hover:bg-[#2bbf5c] hover:text-white" onClick={() => window.location.href = '/'}>Přejít na úvodní stranu</a>
                        </p>
                    </div>
                </React.Fragment>
            );
        }
    }

    return content;
}

export default ProfileCreate;
